import LoadingPattern from "components/LoadingPattern";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectCaseStatus } from "redux/slices/case/";
import { fetchReviewConfig, selectForm, selectFormFieldReviewConfigIds } from "redux/slices/form.slice";
import RequestStatus from "../../../../redux/slices/RequestStatus";
import CasePubnubEvents from "./Case.pubnub";
import CaseFormProvider from "./CaseFormProvider";
import { triggerCaseExportDownload } from "./CaseExports";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";

export default function CaseView() {
  const { lensId, caseId } = useParamNumbers(["lensId", "caseId"]);

  if (lensId === undefined || caseId === undefined) {
    return <Navigate to="/lens" />;
  }

  const reviewConfigIds = useAppSelector(selectFormFieldReviewConfigIds);

  const form = useAppSelector(selectForm);

  const lensCaseStatus = useAppSelector(selectCaseStatus);

  const snackpatch = useAppDispatchWithSnackbar();

  /**
   * Pre-load form field review configs for lightbulb profile linking
   */
  useEffect(() => {
    reviewConfigIds?.forEach((reviewConfigId) =>
      snackpatch(
        fetchReviewConfig({
          reviewConfigId: reviewConfigId.configId,
          fieldId: reviewConfigId.fieldId,
        }),
        {
          errorMessage: "Failed to fetch review config",
        }
      )
    );
  }, [reviewConfigIds]);

  return lensCaseStatus === RequestStatus.SUCCEEDED && form !== undefined ? (
    <CaseFormProvider key={caseId} lensId={lensId} caseId={caseId} form={form}>
      <CasePubnubEvents caseId={caseId} lensId={lensId} triggerCaseExportDownload={triggerCaseExportDownload}>
        <Outlet />
      </CasePubnubEvents>
    </CaseFormProvider>
  ) : (
    <LoadingPattern centered />
  );
}
